angular.module('PatientApp').factory('BrowserInfoService', function($q, $resource, $log, $state, $rootScope, endpoints){

    var ip = $resource(endpoints.patientUser.ip.url);

    var callback;
    return {
        openModal: function(){
            try {
                callback();
            } catch(e) {
                /* eslint-disable no-console */
                console.error('BrowserInfoService.openModal() was called before a callback method had been specified.');
                /* eslint-enable no-console */
            }
        },
        onOpenModal: function(_callback){
            callback = _callback;
        },
        getIPData: function(successCallback, errorCallback){
            ip.get().$promise.then(successCallback, errorCallback);
        }
    };

});